import { MapPin, House, AirplaneTilt, Camera, FilmSlate } from "@phosphor-icons/react";

function Stat({ icon: Icon, value, label, color, testid }) {
  return (
    <div className="rounded-2xl border border-[#E5DFD3] bg-white p-4 text-center" data-testid={testid}>
      <Icon size={22} weight="fill" className="mx-auto" style={{ color }} />
      <p className="mt-1.5 font-display text-2xl font-black text-[#2C2724]">{value}</p>
      <p className="overline text-[9px] text-[#787167]">{label}</p>
    </div>
  );
}

export default function PassportCard({ stats }) {
  if (!stats) return null;
  return (
    <div className="overflow-hidden rounded-3xl border border-[#E5DFD3] bg-[#FFF8EE] shadow-[0_8px_30px_rgba(44,39,36,0.05)]" data-testid="passport-card">
      <div className="brand-sunset flex items-center justify-between px-5 py-4 text-white">
        <div>
          <p className="overline text-[10px] text-white/80">Travel Passport</p>
          <p className="font-display text-3xl font-black">{stats.pct_world}%<span className="ml-1 text-sm font-semibold text-white/80">of the world</span></p>
        </div>
        <div className="text-right">
          <p className="font-display text-2xl font-black">{stats.continents_count}<span className="text-sm text-white/70">/7</span></p>
          <p className="overline text-[9px] text-white/80">continents</p>
        </div>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-3 gap-2.5">
          <Stat icon={MapPin} value={stats.countries_visited} label="Visited" color="#F27A54" testid="stat-visited" />
          <Stat icon={House} value={stats.countries_lived} label="Lived" color="#2D6A4F" testid="stat-lived" />
          <Stat icon={AirplaneTilt} value={stats.countries_next} label="Next" color="#7C3AED" testid="stat-next" />
        </div>
        <div className="mt-2.5 grid grid-cols-2 gap-2.5">
          <Stat icon={Camera} value={stats.photo_count} label="Photos" color="#2D6A4F" testid="stat-photos" />
          <Stat icon={FilmSlate} value={stats.video_count} label="Videos" color="#EC4899" testid="stat-videos" />
        </div>
        {stats.top_countries?.length > 0 && (
          <div className="mt-4">
            <p className="overline mb-2 text-[9px] text-[#787167]">Most photographed</p>
            <div className="flex flex-wrap gap-1.5">
              {stats.top_countries.map((c) => (
                <span key={c.country_code} className="flex items-center gap-1 rounded-full bg-[#F0EBE1] px-2.5 py-1 text-[11px] font-semibold text-[#2C2724]">
                  {c.name} <span className="text-[#A79D8E]">{c.count}</span>
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
